// File/media sizes: decimal units (1000 base) to match OS/AWS style display.
const FILE_SIZE_BASE = 1000;
// Quota/limits: binary units (1024 base) to match byte-based plan limits.
const QUOTA_SIZE_BASE = 1024;

function fileSizeCalculator(bytes) {
    if (bytes && bytes > 0) {
        let size = bytes / FILE_SIZE_BASE / FILE_SIZE_BASE; // Convert to MB
        return size.toFixed(2);
    }
    return null;
}

function prettySize(bytes, separator = '', postFix = '') {
    // Handle null, undefined, or 0 - return "0 Bytes" instead of "n/a"
    if (!bytes || bytes === 0) {
        return `0${separator}Bytes${postFix}`;
    }
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(FILE_SIZE_BASE)).toString(), 10), sizes.length - 1);
    return `${(bytes / FILE_SIZE_BASE ** i).toFixed(i ? 1 : 0)}${separator}${sizes[i]}${postFix}`;
}

function prettyQuotaSize(bytes, separator = '', postFix = '') {
    if (!bytes || bytes === 0) {
        return `0${separator}Bytes${postFix}`;
    }

    // Use binary base for quota math, but keep familiar MB/GB labels in the UI.
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(QUOTA_SIZE_BASE)).toString(), 10), sizes.length - 1);
    return `${(bytes / QUOTA_SIZE_BASE ** i).toFixed(i ? 1 : 0)}${separator}${sizes[i]}${postFix}`;
}

export { fileSizeCalculator, prettySize, prettyQuotaSize };

// import React from 'react'

// function fileSizeCalculator() {
//     return (
//         <div>
            
//         </div>
//     )
// }

// export default fileSizeCalculator
